export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: '#9e9e9e',
        height: '40px',
        lineHeight: '40px',
        boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        paddingTop: '0',
        marginBottom: '10px',
        paddingLeft: '3px',
        paddingRight: '0',
    }),

    input: (provided, state) => ({
        ...provided,
        margin: '0',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '40px',
    }),
};

// New color schemes for the updated UI design
export const pickCityStyles = {
    control: (provided, state) => ({
        ...provided,
        height: '40px',
        minHeight: '40px',
        boxShadow: state.isFocused ? '0 0 0 1px #28a745' : null,
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: '40px',
        paddingTop: '0',
        paddingLeft: '3px',
        paddingRight: '0',
    }),
    input: (provided, state) => ({
        ...provided,
        margin: '0',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '40px',
    }),
};

export const dropCityStyles = {
    control: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        boxShadow: state.isFocused ? '0 0 0 1px #006838' : null,
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        paddingTop: '0',
        marginBottom: '10px',
        paddingLeft: '3px',
        paddingRight: '0',
    }),
    input: (provided, state) => ({
        ...provided,
        margin: '0',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '40px',
    }),
};

export const equipmentTypeStyles = {
    control: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        boxShadow: state.isFocused ? '0 0 0 1px #6c757d' : null,
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        paddingTop: '0',
        marginBottom: '10px',
        paddingLeft: '3px',
        paddingRight: '0',
    }),

    input: (provided, state) => ({
        ...provided,
        margin: '0',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '40px',
    }),
};

export const radiusStyles = {
    control: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '40px',
        lineHeight: '40px',
        paddingTop: '0',
        marginBottom: '10px',
        paddingLeft: '3px',
        paddingRight: '0',
    }),

    input: (provided, state) => ({
        ...provided,
        margin: '0',
        height: '40px',
        lineHeight: '40px',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '40px',
    }),
};

export const daysStyles = {
    control: (provided, state) => ({
        ...provided,
        background: '#fff',
        borderColor: '#9e9e9e',
        minHeight: '20px',
        height: '25px',
        boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '20px',
        paddingTop: '0',
        marginBottom: '10px',
        paddingBottom: '16px',
        paddingLeft: '3px',
        paddingRight: '0',
    }),

    input: (provided, state) => ({
        ...provided,
        margin: '0',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '40px',
    }),
};

// Aliases for radius style used by pick and drop selectors
export const pickRadiusStyles = radiusStyles;
export const dropRadiusStyles = radiusStyles;

export function abbrRegion(input) {

    var isNAN = isNaN(input);
    if (!isNAN) {
        return input;
    }
    var states = [
        ['Alabama', 'AL'],
        ['Alaska', 'AK'],
        ['American Samoa', 'AS'],
        ['Arizona', 'AZ'],
        ['Arkansas', 'AR'],
        ['Armed Forces Americas', 'AA'],
        ['Armed Forces Europe', 'AE'],
        ['Armed Forces Pacific', 'AP'],
        ['California', 'CA'],
        ['Colorado', 'CO'],
        ['Connecticut', 'CT'],
        ['Delaware', 'DE'],
        ['District Of Columbia', 'DC'],
        ['Florida', 'FL'],
        ['Georgia', 'GA'],
        ['Guam', 'GU'],
        ['Hawaii', 'HI'],
        ['Idaho', 'ID'],
        ['Illinois', 'IL'],
        ['Indiana', 'IN'],
        ['Iowa', 'IA'],
        ['Kansas', 'KS'],
        ['Kentucky', 'KY'],
        ['Louisiana', 'LA'],
        ['Maine', 'ME'],
        ['Marshall Islands', 'MH'],
        ['Maryland', 'MD'],
        ['Massachusetts', 'MA'],
        ['Michigan', 'MI'],
        ['Minnesota', 'MN'],
        ['Mississippi', 'MS'],
        ['Missouri', 'MO'],
        ['Montana', 'MT'],
        ['Nebraska', 'NE'],
        ['Nevada', 'NV'],
        ['New Hampshire', 'NH'],
        ['New Jersey', 'NJ'],
        ['New Mexico', 'NM'],
        ['New York', 'NY'],
        ['North Carolina', 'NC'],
        ['North Dakota', 'ND'],
        ['Northern Mariana Islands', 'NP'],
        ['Ohio', 'OH'],
        ['Oklahoma', 'OK'],
        ['Oregon', 'OR'],
        ['Pennsylvania', 'PA'],
        ['Puerto Rico', 'PR'],
        ['Rhode Island', 'RI'],
        ['South Carolina', 'SC'],
        ['South Dakota', 'SD'],
        ['Tennessee', 'TN'],
        ['Texas', 'TX'],
        ['US Virgin Islands', 'VI'],
        ['Utah', 'UT'],
        ['Vermont', 'VT'],
        ['Virginia', 'VA'],
        ['Washington', 'WA'],
        ['West Virginia', 'WV'],
        ['Wisconsin', 'WI'],
        ['Wyoming', 'WY'],
    ];

    // So happy that Canada and the US have distinct abbreviations
    var provinces = [
        ['Alberta', 'AB'],
        ['British Columbia', 'BC'],
        ['Manitoba', 'MB'],
        ['New Brunswick', 'NB'],
        ['Newfoundland', 'NF'],
        ['Northwest Territory', 'NT'],
        ['Nova Scotia', 'NS'],
        ['Nunavut', 'NU'],
        ['Ontario', 'ON'],
        ['Prince Edward Island', 'PE'],
        ['Quebec', 'QC'],
        ['Saskatchewan', 'SK'],
        ['Yukon', 'YT'],
    ];

    var regions = states.concat(provinces);

    var i; // Reusable loop variable
    // if (to == 'abbr') {
        input = input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        for (i = 0; i < regions.length; i++) {
            if (regions[i][0] == input) {
                return (regions[i][1]);
            }
        }
    // }

    // else if (to == 'name') {
    //     input = input.toUpperCase();
    //     for (i = 0; i < regions.length; i++) {
    //         if (regions[i][1] == input) {
    //             return (regions[i][0]);
    //         }
    //     }
    // }
}